import React from 'react'
import Layout from '../../components/layout/Layout'
import SupportsTable from '../../elements/tables/supports/SupportsTable'

export default function AllSupports() {
  return (
    <div>
      <Layout>
        <SupportsTable />
      </Layout>
    </div>
  )
}
